import constate from "constate";
import { type Map } from "immutable";
import { useCallback } from "react";
import { getApprovalFlows, getApprovalFlow as apiGetApprovalFlow } from "api/approvalFlow";
import { useFetchedState } from "hooks/useFetchedState";
import { useOpenGlobalErrorModal } from "hooks/useGlobalError";
import { type ApprovalFlowModel } from "models/ApprovalFlowModel";

const useApprovalFlows = () => {
	const {
		data: approvalFlows,
		setData: setApprovalFlows,
		loadData: loadApprovalFlows
	} = useFetchedState(getApprovalFlows);

	const openGlobalErrorModal = useOpenGlobalErrorModal();

	const getApprovalFlow = useCallback(
		async (id: string) => {
			try {
				return await apiGetApprovalFlow(id);
			} catch (error) {
				openGlobalErrorModal(error as Error);
				return null;
			}
		},
		[openGlobalErrorModal]
	);

	const addApprovalFlows = useCallback(
		(approvalFlowsToAdd: Map<string, ApprovalFlowModel>) => {
			setApprovalFlows(approvalFlows => (approvalFlows ? approvalFlows.merge(approvalFlowsToAdd) : approvalFlowsToAdd));
		},
		[setApprovalFlows]
	);

	return {
		state: { approvalFlows },
		actions: { loadApprovalFlows, getApprovalFlow, addApprovalFlows }
	};
};

export const [ApprovalFlowsProvider, useApprovalFlowsContext] = constate(useApprovalFlows);
